import React from 'react';
import {
    css,
    Button,
    Header,
    Div,
    Grid,
    GridCell,
} from "@bdfx/fukit"
import {formatDatetime} from "../../common/format"
import history from "../../common/history"
import {shadow,clip} from "../homepage/section"
import ctrans from "../../common/trans"
import ExportButton from './export-button';
import { getAuditUrl } from '../helpers';

interface Props {
    children: React.ReactNode
    data: any
    index?: string | null
    title?: string | null
}

const ResultHeader = ({children, data, index = null, title = null }: Props) => {

    const locale = data?.shop?.heureka_locale
    const slug = data?.shop?.slug
    const linkHref = `https://obchody.heureka.${locale}/${slug}`
    
    return (
        <Style className="section">
            <div>
            <HeaderContent>
                <Div className="report-info" textAlign="right">
                    <ShopLink href={linkHref} target="_blank" rel="nofollow, noreferrer">
                        {data?.shop?.name}
                    </ShopLink>
                    <br/>
                    {ctrans("report_generated")}: {formatDatetime(data?.updated_at)}
                </Div>
                <Grid cols="230px 1fr 230px" valign="center" className="title">
                    {index ? <GridCell align="left"><Button size="small" onClick={() => history.push(getAuditUrl(data.id))} secondary={true} color="green"  icon={"chevron-left-light"}>{ctrans("back_to_result")}</Button></GridCell> : <div/>}
                    <Header type={1}>
                        {title ? title : ctrans("audit_result") + " / " + data?.shop?.name}
                    </Header>
                    <GridCell align="right">
                        {index !== null ? 
                        <>
                            <ExportButton auditId={data.id} index={index} size="small" color="green" />
                            &nbsp;
                        </> : null}
                        <Button secondary={true} onClick={window.print} size="small" color="green" icon={"print-light"}>{ctrans("print")}</Button>
                    </GridCell>
                </Grid>

                {children}
            </HeaderContent>
            </div>
        </Style>
    )
}

const Style = css("div")({
    "@media only screen and (max-width: 1000px)": {
        ".fuk-grid": {
            display: "block",
            ".fuk-header": {
                margin: "0.5em",
            }
        }
    },
    filter: shadow,
    position: "relative",
    zIndex: 50,
    ".h1": {
        fontSize: "32px",
        lineHeight: "32px",
    },
    ".title": {
        paddingTop: "1rem",
    },
    "> div": {
        clipPath: clip,
        background: "#f6f6f6",
      paddingTop: "4em",
      paddingBottom: "100px",

    },
    ".fuk-header": {
        marginTop: 0,
        marginBottom: 0,
    },
    "p": {
        textAlign: "justify",
        padding:"0",
        fontSize: "1.4em",
    }
})

const HeaderContent = css("div")({
    margin: "auto",
    maxWidth: "1100px",
    ".print-button": {
    }, 
})

const ShopLink = css("a")({
    display: "inline-block",
    textAlign: "right",
    fontSize: "1.2em",
    fontWeight: 700,
})

export default ResultHeader